import { env, locale, phraseUrl } from 'utils/settings';
import Translations from '../../public/phrase/en-XZ.json';

const fetchPhraseIfNeeded = () => {
    if (window.ikea?.favourites?.text) {
        return Promise.resolve();
    }

    const path =
        env === 'localhost'
            ? `${phraseUrl}phrase/${locale}.json`
            : `${phraseUrl}agent/phrase/${locale}.json`;

    return fetch(path)
        .then(response => response.json())
        .then((text: typeof Translations) => {
            window.ikea.favourites.text = text;
        })
        .catch(err => console.error('Can´t get translations file', err));
};

export default fetchPhraseIfNeeded;
